export enum MerchantPreferredBrand {
  VISA = 'VISA,CB',
  VPAY = 'VPAY,CB',
  MASTERCARD = 'MASTERCARD,CB',
  ELECTRON = 'ELECTRON,CB',
  MAESTRO = 'MAESTRO,CB',
}
